export default {
    permissionUnitsTitle: 'Title ',
    permissionUnitsEn: 'Title En',
    permissionUnitsKey: ' Key',
}